import { BloodthurstConfig } from 'game/extended/heros/barbarian/bloodthurst/bloodthurst'

export const bloodthurst_config: Array<BloodthurstConfig> = [
    {
        regeneration: 6
    },
    {
        regeneration: 12
    }
]